import React from 'react';
import { SettingsListType } from './types';
import { Switch } from '@cokitchen/cokitchen-components';
import useDashboardContext from 'contexts/dashboard.context';

type Props = { list: SettingsListType[] };

const ProfileSettings = ({ list }: Props) => {
  const { activeCompany } = useDashboardContext();

  return (
    <div>
      <label className='text-gray-9'>Settings</label>
      <div className='space-y-4 mt-6'>
        {list?.map(({ label, onClick, value, budgetType, isNotification, buttonText }, i) => (
          <div className='flex items-center border-b border-b-gray-13 pb-4 ' key={i}>
            <div className='flex flex-col grow'>
              <label className='text-xs text-gray-9'>{label}</label>
              <p className='text-sm'>
                {value}
                {budgetType && <span className='text-blue-5 font-medium'>{budgetType}</span>}
              </p>
            </div>

            {isNotification ? (
              <Switch active={activeCompany?.receive_notification} onChange={onClick} small />
            ) : (
              <button
                className='w-[86px] h-[34px] rounded-[100px] bg-[#F2F2F2] hover:bg-gray-4 font-medium text-xs text-gray-9'
                onClick={onClick}>
                {buttonText ? buttonText : 'Change'}
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileSettings;
